
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { authApi } from '../../api/api'
import { disconnectSocket, initSocket } from '../../utilies/config'

export const customer_register = createAsyncThunk(
    'auth/customer_register',
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await authApi.post('/customer/customer-register', info)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Qeydiyyat zamanı xəta baş verdi', status: error.response?.status })
        }
    }
)

// 🆕 Verify Registration (Kod təsdiqi)
export const verify_registration = createAsyncThunk(
    'auth/verify_registration',
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await authApi.post('/customer/verify-registration', info)
            initSocket()   // ← connect socket (cookie already set by backend)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Kod təsdiqi zamanı xəta baş verdi', status: error.response?.status })
        }
    }
)

export const customer_login = createAsyncThunk(
    'auth/customer_login',
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await authApi.post('/customer/customer-login', info)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue({
                ...(error.response?.data || { error: 'Giriş zamanı xəta baş verdi. Zəhmət olmasa yenidən cəhd edin.' }),
                status: error.response?.status
            })
        }
    }
)

export const verify_customer_login_otp = createAsyncThunk(
    'auth/verify_customer_login_otp',
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await authApi.post('/customer/login-otp/verify', info)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue({
                ...(error.response?.data || { error: 'Kod təsdiqlənə bilmədi.' }),
                status: error.response?.status
            })
        }
    }
)

export const resend_customer_login_otp = createAsyncThunk(
    'auth/resend_customer_login_otp',
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await authApi.post('/customer/login-otp/resend', info)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue({
                ...(error.response?.data || { error: 'Yeni kod göndərilə bilmədi.' }),
                status: error.response?.status
            })
        }
    }
)

export const customer_logout = createAsyncThunk(
    'auth/customer_logout',
    async (_, { fulfillWithValue }) => {
        try {
            const { data } = await authApi.get('/customer/logout')
            return fulfillWithValue(data)
        } catch (error) {
            return fulfillWithValue({ message: 'Logout success' })
        } finally {
            disconnectSocket()
        }
    }
)

export const get_current_customer = createAsyncThunk(
    'auth/get_current_customer',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await authApi.get('/customer/me')
            initSocket()
            return fulfillWithValue(data)
        } catch (error) {
            disconnectSocket()
            return rejectWithValue(error.response?.data || { error: 'Session check failed' })
        }
    }
)

// 🆕 Phase 2 — Profil (ad / telefon / avatar) yenilənməsi
export const get_customer_profile = createAsyncThunk(
    'auth/get_customer_profile',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await authApi.get('/customer/profile')
            return fulfillWithValue(data)
        } catch (error) {
            if (error.response?.status === 401) {
                return rejectWithValue({ error: 'Sessiyanız bitib. Profilə baxmaq üçün yenidən daxil olun.', status: 401 })
            }
            return rejectWithValue(error.response?.data || { error: 'Profil yüklənə bilmədi' })
        }
    }
)

export const update_customer_profile = createAsyncThunk(
    'auth/update_customer_profile',
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await authApi.patch('/customer/profile', info)
            return fulfillWithValue(data)
        } catch (error) {
            if (error.response?.status === 401) {
                return rejectWithValue({ error: 'Sessiyanız bitib. Profili yeniləmək üçün yenidən daxil olun.', status: 401 })
            }
            return rejectWithValue(error.response?.data || { error: 'Profil yenilənə bilmədi' })
        }
    }
)
export const authReducer = createSlice({
    name: 'auth',
    initialState: {
        loader: false,
        userInfo: '',
        authChecked: false,
        isBanned: false,
        banReason: '',
        errorMessage: '',
        successMessage: '',
        profile: null,
        profileLoader: false,
        pendingLoginOtp: null
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = ''
            state.successMessage = ''
        },
        clearBanStatus: (state) => {
            state.isBanned = false
            state.banReason = ''
            state.errorMessage = ''
        },
        user_reset: (state) => {
            state.userInfo = ""
            state.authChecked = true
            state.isBanned = false
            state.banReason = ''
            state.errorMessage = ''
            state.successMessage = ''
            state.pendingLoginOtp = null
        },
        clear_pending_login_otp: (state) => {
            state.pendingLoginOtp = null
            state.errorMessage = ''
            state.successMessage = ''
        },
         set_oauth_user: (state, { payload }) => {
        state.userInfo = payload.userInfo
        state.successMessage = payload.successMessage
        state.authChecked = true
        state.loader = false
    }

    },
    extraReducers: (builder) => {
        builder
            // Register (Email göndərmə)
            .addCase(customer_register.pending, (state) => {
                state.loader = true
            })
            .addCase(customer_register.rejected, (state, { payload }) => {
                state.errorMessage = payload.error || 'Qeydiyyat zamanı xəta baş verdi'
                state.loader = false
            })
            .addCase(customer_register.fulfilled, (state, { payload }) => {
                // Email göndərildi, amma hələ hesab yaradılmayıb
                state.successMessage = payload.message
                state.loader = false
            })
            
            // 🆕 Verify Registration (Kod təsdiqi + Hesab yaradılması)
            .addCase(verify_registration.pending, (state) => {
                state.loader = true
            })
            .addCase(verify_registration.rejected, (state, { payload }) => {
                state.errorMessage = payload.error || 'Kod təsdiqi zamanı xəta'
                state.loader = false
            })
            .addCase(verify_registration.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
                state.loader = false
                state.userInfo = payload.userInfo || ''
                state.authChecked = true
            })
            
            // Login
            .addCase(customer_login.pending, (state) => {
                state.loader = true
                state.errorMessage = ''
            })
            .addCase(customer_login.rejected, (state, { payload }) => {
                if (payload?.isBanned) {
                    state.errorMessage = 'Hesabınız bloklanıb'
                    state.isBanned = true
                    state.banReason = payload.reason || 'Səbəb göstərilməyib'
                } else {
                    state.errorMessage = payload?.error || 'Giriş xətası'
                    state.isBanned = false
                    state.banReason = ''
                }
                state.loader = false
            })
            .addCase(customer_login.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
                state.loader = false
                state.pendingLoginOtp = payload.requiresOtp ? {
                    challengeId: payload.challengeId,
                    expiresIn: payload.expiresIn,
                    resendAfter: payload.resendAfter
                } : null
                state.userInfo = ''
                state.isBanned = false
                state.banReason = ''
            })
            .addCase(verify_customer_login_otp.pending, (state) => {
                state.loader = true
                state.errorMessage = ''
            })
            .addCase(verify_customer_login_otp.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Kod təsdiqlənə bilmədi.'
            })
            .addCase(verify_customer_login_otp.fulfilled, (state, { payload }) => {
                state.loader = false
                state.userInfo = payload.userInfo || ''
                state.authChecked = true
                state.pendingLoginOtp = null
                state.successMessage = payload.message
            })
            .addCase(resend_customer_login_otp.pending, (state) => {
                state.loader = true
            })
            .addCase(resend_customer_login_otp.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Yeni kod göndərilə bilmədi.'
            })
            .addCase(resend_customer_login_otp.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
                if (state.pendingLoginOtp) {
                    state.pendingLoginOtp.expiresIn = payload.expiresIn
                    state.pendingLoginOtp.resendAfter = payload.resendAfter
                }
            })
            
            // Logout
            .addCase(customer_logout.fulfilled, (state) => {
                state.userInfo = ''
                state.authChecked = true
                state.successMessage = 'Çıxış uğurla tamamlandı'
                state.loader = false
                state.isBanned = false
                state.banReason = ''
                state.pendingLoginOtp = null
            })
            .addCase(get_current_customer.pending, (state) => {
                state.loader = true
            })
            .addCase(get_current_customer.fulfilled, (state, { payload }) => {
                state.loader = false
                state.authChecked = true
                state.userInfo = payload.userInfo || ''
                state.isBanned = false
                state.banReason = ''
            })
            .addCase(get_current_customer.rejected, (state) => {
                state.loader = false
                state.authChecked = true
                state.userInfo = ''
            })

            // 🆕 Phase 2 — Profil oxu
            .addCase(get_customer_profile.pending, (state) => {
                state.profileLoader = true
            })
            .addCase(get_customer_profile.fulfilled, (state, { payload }) => {
                state.profileLoader = false
                state.profile = payload.profile || null
            })
            .addCase(get_customer_profile.rejected, (state, { payload }) => {
                state.profileLoader = false
                state.errorMessage = payload?.error || 'Profil yüklənə bilmədi'
            })

            // 🆕 Phase 2 — Profil yenilə
            .addCase(update_customer_profile.pending, (state) => {
                state.profileLoader = true
                state.errorMessage = ''
            })
            .addCase(update_customer_profile.fulfilled, (state, { payload }) => {
                state.profileLoader = false
                state.successMessage = payload.message || 'Profil yeniləndi'
                state.profile = payload.profile || state.profile
                // Header/sidebar dərhal yenilənsin deyə userInfo-nu da yeniləyirik
                if (state.userInfo && payload.profile) {
                    state.userInfo = {
                        ...state.userInfo,
                        name:        payload.profile.name,
                        phone:       payload.profile.phone,
                        avatarId:    payload.profile.avatarId,
                        avatarColor: payload.profile.avatarColor
                    }
                }
            })
            .addCase(update_customer_profile.rejected, (state, { payload }) => {
                state.profileLoader = false
                state.errorMessage = payload?.error || 'Profil yenilənə bilmədi'
            })
    }
})

export const { messageClear, user_reset, clearBanStatus, set_oauth_user, clear_pending_login_otp } = authReducer.actions
export default authReducer.reducer
